<!-- ======= Hero Section ======= -->
<section class="login-page-section-top ">
  <div class="container">
    <div class="row">
      <div class="col-md-12 size-img back-img">
        <div class="effect-cover">
          <h3 class="txt-advert animated fadeInUp">Tennis Premier League </h3>
          <p class="txt-advert-sub animated">Your all-access pass to experience the action on tour</p>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
    <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
      <div class="headings image-card">
        <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
        <div class="slider-inner-div">
          <div class="container">
            <div class="main-heading-banner">
              <!-- <div class="headings-section-banner">
    <h4 class="tracking-in-contract">CREATIVE</h4>
    <div class="main-heading tracking-in-contract new">
      WEB DESIGN.
    </div>
  </div> -->
              <div class="sldier-bottom-section"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">

    <!-- *ngIf="showsignupMsg" -->
    <div class="col-xs-6 success-msg" *ngIf="showsignupMsg">
      <p class="alert alert-success">
        <strong> Your password has been reset successfully</strong>
      </p>
    </div>

    <div class="col-md-12 login-page">
      <div class="row justify-content-center">
        <div class="col-lg-12">

          <div class="row main-row tab-content" id="pills-tabContent">
            <div class="col-12 my-account-div tab-pane fade show active" id="pills-sign-in" role="tabpanel"
              aria-labelledby="pills-sign-in-tab" tabindex="0">
              <div class="top-header-heading">
                <h4 class="accounts-headings text-center">
                  <span> Reset Password</span>
                </h4>
              </div>
            </div>

            <form [formGroup]="resetPassForm">

              <div class="row">
                <div class="col-lg-12">
                  <div class="style-form-group">
                    <p-password [toggleMask]="true" formControlName="password" class="w-100" placeholder="Password"
                      [ngClass]="{ 'is-invalid': submitted && f.password.errors }"></p-password>
                    <!-- <input pPassword type="password"> -->
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                      <div *ngIf="f.password.errors.required">Password is required</div>
                      <div *ngIf="f.password.errors">Password should contains at least 1 digit, 1
                        lowercase, 1 uppercase, 1 symbol.
                        Length between 6 to 20.</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="style-form-group">
                    <p-password [toggleMask]="true" formControlName="confirmPassword" class="p-mb-3 w-100"
                      style="width: 100%;" placeholder="Confirm Password"
                      [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                    </p-password>
                    <!-- <input pPassword type="password"> -->
                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                      <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                      <div *ngIf="f.confirmPassword.errors.mustMatch">Password and Confirm Password must be match.</div>
                    </div>
                  </div>
                </div>
                <div *ngIf="showError">
                  <span class="mandatory-feilds">{{errorMessage}}</span>
                </div>

              </div>

              <div class="subminbutton">
                <div class="button pt-2 pt-lg-3">
                  <a pButton class="text-uppercase min-1" (click)="submit()">Submit</a>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
      <p class="py-2"></p>
    </div>



  </div>
  <p-toast key="toastMsg"></p-toast>
</section>